import axios from 'axios';
import { toast } from 'react-toastify';
import * as Sentry from '@sentry/react';
import { LOADING_MUTATIONS, LOADING_MUTATIONS_DONE } from 'redux/actions/types';
export const sendQuery = async (
  query,
  operationName = null,
  variables = {}
) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/graphql`,

      {
        operationName,
        variables,
        query,
      }
    );

    if (res.data.errors) {
      throw new Error(JSON.stringify(res.data.errors));
    }

    return res.data;
  } catch (e) {
    Sentry.captureException({
      query,
      variables: JSON.stringify(variables),
      operationName,
      message: e.message,
    });
    return { data: {} };
  }
};

export const sendMutation = async (
  dispatch,
  query,
  operationName = null,
  variables = {}
) => {
  try {
    if (dispatch) {
      dispatch({ type: LOADING_MUTATIONS });
    }
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/graphql`,

      {
        operationName,
        variables,
        query,
      }
    );
    if (res.data.errors) {
      throw new Error(res.data.errors[0].message);
    }
    if (dispatch) {
      dispatch({ type: LOADING_MUTATIONS_DONE });
    }
    return res.data;
  } catch (e) {
    if (dispatch) {
      dispatch({ type: LOADING_MUTATIONS_DONE });
    }
    Sentry.captureException({
      query,
      variables: JSON.stringify(variables),
      operationName,
      message: e.message,
    });
    toast.error(e.message);
    return e;
  }
};
